<!-- 产品中心，企业数字化管理平台及数据中台，产品优势组件 -->
<template>
    <div class="product-advantages-item">
        <div class="img-box"><img :src="info.imgUrl"></div>
        <div class="title">{{ info.title }}</div>
        <div class="text">{{ info.text }}</div>
    </div>
</template>

<script>
export default {
    name: 'ProductAdvantagesItemEnterpriseMngPlatform',
    props:{
        info: {
            require: true
        }
    }
}
</script>

<style scoped lang="scss">
    .product-advantages-item{
        box-sizing: border-box;
        width: 360px;
        height: 360px;
        padding: 40px 40px 0px;
        text-align: center;
        cursor: pointer;
        @media screen and (max-width: 600px) {
            width: 187px;
            height: auto;
            padding: 15px 17px;
            box-sizing: border-box;
            height: auto;
            margin: 0 auto;
        }
        &:hover{
            background: #F7F9FF;
            box-shadow: 1px 0px 15px 2px rgba(0,0,0,0.0700);
        }
        .img-box{
            width: 68px;
            height: 68px;
            margin: 0 auto;
            @media screen and (max-width: 600px) {
                width: 50px;
                height: 50px;
            }
            img{
                width: 68px;
                height: 68px;
                @media screen and (max-width: 600px) {
                    width: 50px;
                    height: 50px;
                }
            }
        }
        .title{
            margin-top: 32px;
            height: 28px;
            font-size: 20px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #4970E0;
            line-height: 28px;
            margin-bottom: 20px;
            @media screen and (max-width: 600px) {
                margin-top: 15px;
                height: 40px;
                font-size: 15px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #4970E0;
                line-height: 21px;
                margin-bottom: 10px;
            }
        }
        .text{
            width: 280px;
            height: 125px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgb(104, 104, 104);
            line-height: 25px;
            @media screen and (max-width: 600px) {
                font-size: 13px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #151515;
                line-height: 18px;
                width: auto;
                height: auto;
            }
        }
    }
</style>
